module.exports = __webpack_public_path__ + "static/media/Icond-2.3e7bfb97.svg";